import { create } from 'zustand'
import { persist } from 'zustand/middleware'

export type ThemeName =
  | 'default'
  | 'citysurvival'
  | 'neonvice'
  | 'bloodmoon'
  | 'matrix'
  | 'goldenhour'
  | 'abyss'
  | 'toxic'
  | 'sakura'
  | 'vault'
  | 'void'
  | 'premiumglass'

export const THEME_LABELS: Record<ThemeName, string> = {
  default: 'Indigo (Standard)',
  citysurvival: 'City Survival',
  neonvice: 'Neon Vice',
  bloodmoon: 'Bloodmoon',
  matrix: 'Matrix Terminal',
  goldenhour: 'Golden Hour',
  abyss: 'Abyss',
  toxic: 'Toxic Wasteland',
  sakura: 'Sakura Night',
  vault: 'Vault',
  void: 'Void',
  premiumglass: 'Premium Glass',
}

interface ThemeState {
  theme: ThemeName
  setTheme: (theme: ThemeName) => void
}

export const useThemeStore = create<ThemeState>()(
  persist(
    (set) => ({
      theme: 'default',
      setTheme: (theme) => set({ theme }),
    }),
    { name: 'ntl-theme' },
  ),
)

export function applyThemeAttribute(theme: ThemeName): void {
  document.documentElement.setAttribute('data-theme', theme)
}
